import { useState } from "react";
import { useNavigate } from "react-router";
import { useForm, ValidationError } from "@formspree/react";

// import pages
import FooterB from "../layout/FooterB";

// import style
import "../../style/pages/auth/contact.scss";

const Contact = () => {
  const router = useNavigate();
  const [state, handleSubmit] = useForm(
    process.env.REACT_APP_FORMSPREE_CONTACT_ID || ""
  );
  const [formData, setFormData] = useState({
    topic: "",
    firstName: "",
    lastName: "",
    email: "",
    emailConfirm: "",
    message: "",
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    // Custom validation
    if (formData.email !== formData.emailConfirm) {
      setError("Email addresses do not match.");
      return;
    }
    setError("");
    await handleSubmit({
      ...formData,
      emailConfirm: undefined,
    });
  };

  if (state.succeeded) {
    setTimeout(() => {
      router("/thanks");
    }, 500);
  }

  return (
    <div className="contact-section">
      <div className="container main-section">
        <div className="responsive-main-section">
          <div className="title-section background-lightgreen">
            <a href="/contact" className="title-link">
              <div className="title font-amaticsc-bold">Contact Us</div>
              <div className="sub-title font-zenkurenaido">お問い合わせ</div>
            </a>
          </div>
          <form onSubmit={onSubmit} className="content-section">
            <div className="field">
              <select
                className="input-text font-outfit"
                name="topic"
                value={formData.topic}
                onChange={handleChange}
                required
              >
                <option disabled value="">
                  I have a question about...
                </option>
                <option value="classes">Classes (クラス)</option>
                <option value="media">Media (メディア関連)</option>
                <option value="payment">Payment (お支払・請求)</option>
                <option value="registration">
                  Registration (お申し込み・登録){" "}
                </option>
                <option value="private_lessons">
                  Private Lessons (個人レッスン){" "}
                </option>
                <option value="request_class">
                  Request a Class (クラス開講のリクエスト)
                </option>
                <option value="other">Other Questions (その他のご質問)</option>
              </select>
            </div>
            <div className="field">
              <input
                type="text"
                className="input-text font-outfit"
                placeholder="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                className="input-text font-outfit"
                placeholder="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
            <ValidationError
              prefix="Email"
              field="email"
              errors={state.errors}
            />
            <div className="field">
              <input
                type="email"
                className="input-text font-outfit"
                placeholder="Email Address"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                className="input-text font-outfit"
                placeholder="Confirm Email Address"
                value={formData.emailConfirm}
                onChange={handleChange}
                name="emailConfirm"
                required
              />
            </div>
            <div className="field">
              <textarea
                className="input-textarea font-outfit"
                placeholder="Type your message..."
                rows={3}
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <ValidationError
              prefix="Message"
              field="message"
              errors={state.errors}
            />

            {error && <p className="col-span-2 text-red-500">{error}</p>}

            <div className="field">
              <div className="button-text">
                <button
                  type="submit"
                  disabled={state.submitting}
                  className="footer-btn font-amaticsc-bold"
                >
                  Submit
                  <span className="btn-text font-amaticsc-bold">送信</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <FooterB />
    </div>
  );
};

export default Contact;
